<template>
  <filial-settings-view
    title="Методы оплаты"
    :keys="keys"
    category="payment"
  >
    <template #field="{ row, disabled, onInput, settings }">
      <template v-if="row.type === 'payment_methods_table'">
        <payment-by-delivery-relation-settings
          v-show="row.isDefaultValue"
          :value="row.defaultValue"
          :online-payment-enabled="isOnlinePaymentEnabled(settings)"
          disabled
        />
        <payment-by-delivery-relation-settings
          v-show="!row.isDefaultValue"
          v-model="row.value"
          :online-payment-enabled="isOnlinePaymentEnabled(settings)"
          :disabled="disabled"
          @input="onInput"
        />
      </template>
    </template>
  </filial-settings-view>
</template>

<script>
  import FilialSettingsView from '@/components/ui/crud/fields/filials/FilialSettingsView.vue'
  import PaymentByDeliveryRelationSettings from '@/components/ui/crud/fields/filial-settings/PaymentByDeliveryRelationSettings.vue'
  import SettingKey from '@/models/enums/SettingKey'

  export default {
    name: 'PaymentMethodsSettings',
    components: { FilialSettingsView, PaymentByDeliveryRelationSettings },
    data () {
      return {
        keys: [SettingKey.PaymentMethodsEnabled],
      }
    },
    methods: {
      isOnlinePaymentEnabled (settings) {
        const row = settings.find((s) => s.key === 'onlinePaymentEnabled')
        if (!row) return true
        const val = row.isDefaultValue ? row.defaultValue : row.value
        return val === 1 || val === '1' || val === true || val === 'true'
      },
    },
  }
</script>
